
import { BaseNotificationsActionTypes } from './base-notification.actions';
import { BaseNotification } from './base-notification.model';
import { baseInitialState, BaseNotificationsState } from './base-notification.state';

export function baseNotificationsReducer(state = baseInitialState, action: any): BaseNotificationsState {
    switch (action.type) {
        case BaseNotificationsActionTypes.LoadBaseNotificationsSuccess:
            return {
                ...state,
                itemList: action.payload,
                loaded: true
            };
        case BaseNotificationsActionTypes.SetBaseNotificationsAsReadSuccess:
            const index = state.itemList.findIndex(u => u.id === action.payload.id);
            const newitems: BaseNotification[] = [...state.itemList];
            newitems.splice(index, 1);
            return {
                ...state,
                itemList: newitems
            };
        default:
            return state;
    }
}
